/**
 * Maps a `SocialLink.platform` value to the logo the footer draws for it.
 *
 * Keyed by the exact strings `ContentPane.vue`'s `SOCIAL_PLATFORMS`
 * constrains the admin's platform picker to — this file is the other half of
 * that list. An operator's stored `platform` is free text on the backend
 * (see that constant's own doc), so a value outside that list — a link
 * created before the picker existed, or added directly against the API —
 * has no entry here and `iconFor()` answers `null` for it; the footer falls
 * back to a plain text link rather than drawing a broken image.
 */
const SOCIAL_ICONS: Record<string, string> = {
  Instagram: '/assets/social/instagram.svg',
  Facebook: '/assets/social/facebook.svg',
  X: '/assets/social/x.svg',
  Threads: '/assets/social/threads.svg',
  Discord: '/assets/social/discord.svg',
  YouTube: '/assets/social/youtube.svg',
  Snapchat: '/assets/social/snapchat.svg',
  Telegram: '/assets/social/telegram.svg',
};

export function iconFor(platform: string): string | null {
  return SOCIAL_ICONS[platform] ?? null;
}
